// Hardcoded fallback position – Náměstí Míru, Praha
// Used when REACT_APP_DEFAULT_CENTER_LAT/LNG env vars are not set
export const DEFAULT_LAT = 50.07475212146024
export const DEFAULT_LNG = 14.436753798477579

interface TrackLocationProps {
    onSuccess: PositionCallback
    onError: PositionErrorCallback
}

// use navigator.geolocation.watchPosition to watch user's position
export const watchPosition = ({ onSuccess, onError }: TrackLocationProps) => {
    if ('geolocation' in navigator === false) {
        return new Error('Geolocation is not supported by your browser.')
    }

    return navigator.geolocation.watchPosition(onSuccess, onError, {
        enableHighAccuracy: false,
        timeout: 20000,
        maximumAge: 30000, // Reuse cached position up to 30s
    })
}

// use navigator.geolocation.getCurrentPosition to get user's current position
export const getCurrentPosition = ({
    onSuccess,
    onError,
}: TrackLocationProps) => {
    if ('geolocation' in navigator === false) {
        return new Error('Geolocation is not supported by your browser.')
    }

    return navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        timeout: 20000,
        maximumAge: 0, // Force fresh calculation to ensure Safari triggers the permission prompt
        enableHighAccuracy: false,
    })
}
